/*******************************************************************************
 * File: BannerText.js
 * Summary: Demo website header (across all pages)
 ******************************************************************************/

/*******************************************************************************
 * Section: Imports
 ******************************************************************************/
import styled from 'styled-components'

/*******************************************************************************
 * Section: Custom Divs
 ******************************************************************************/

const BannerDiv = styled.div`
  position: relative;
  margin: 60px auto 25px;
  padding: 50px 13px;
  max-width: 1060px;
  color: #fff;
  text-align: center;
`

const H1 = styled.h1`
  font-weight: 900;
  font-size: 53px;
  font-family: 'RobotoMono';
  line-height: 60px;
  letter-spacing: -5%;
  text-align: center;
  vertical-align: middle;
  margin: 15px;
`

const H2 = styled.h2`
  font-weight: 400;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-bottom: 30px;
`

const BannerButton = styled.button`
  // Figma
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  height: 39px;

  // Custom
  background-color: transparent;
  color: #ffffff;
  padding: 0px 30px;
  border: solid;
  border-width: 1px;
  border-radius: 39px;
`

/*******************************************************************************
 * Function: Header
 * Summary: Renders Header across all pages for website
 ******************************************************************************/
function BannerText(props) {
  return (
    <BannerDiv>
      <H1>
        Top 10 Trending
        <br></br>
        Destinations
      </H1>
      <H2>Find your next great adventure</H2>
      <BannerButton>Learn More</BannerButton>
    </BannerDiv>
  )
}

export default BannerText
